import React from 'react'
import PropTypes from 'prop-types'

import MainLayout from '../../layouts/Main'
import { PageTitle } from '../../components'
import {
    Mila, Elena, Kamen, Antoaneta, Atanaska, Elisaveta,
    Ilia, Mariana, Milena, Roberto, Svetlana, Viara, Zdravko
} from '../../modules/OurTeam'

const TeamView = () => {
    return (
        <MainLayout>
            <div className="row justify-content-center">
                <main className="col-md-12 col-lg-10">
                    <PageTitle>Авторите на проекта</PageTitle>
                    <div className="card-deck">
                        <Mila/>
                        <Elena/>
                        <Kamen/>
                        <Svetlana/>
                        <Antoaneta/>
                        <Atanaska/>
                        <Viara/>
                        <Mariana/>
                        <Milena/>
                        <Roberto/>
                        <Elisaveta/>
                        <Zdravko/>
                        <Ilia/>
                    </div>
                </main>
            </div>
        </MainLayout>
    )
}

TeamView.propTypes = {
    
}

export default TeamView



// WEBPACK FOOTER //
// ./src/views/Team/index.js